import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { Box, styled, Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { Points } from '../../points';
import { QuestionWrapper } from '../questions/question-inputs';
import QuizInput from './quiz-input';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ContentWrapper = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiBox-root:last-child {\n    margin-bottom: 0;\n  }\n"])));

var QuizWrapper = function QuizWrapper(_ref) {
  var _quiz$points;

  var quiz = _ref.quiz,
      hasError = _ref.hasError,
      children = _ref.children;
  return /*#__PURE__*/_jsxs(QuestionWrapper, {
    id: quiz.id,
    question: quiz,
    verticalSpacing: 3,
    hasError: hasError,
    "data-element": "QuestionWrapper",
    "data-component": "QuizWrapper",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        mb: 2,
        color: function color(t) {
          return t.palette.neutral.light;
        }
      },
      "data-element": "Box",
      "data-component": "QuizWrapper",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(Points, {
        points: (_quiz$points = quiz.points) !== null && _quiz$points !== void 0 ? _quiz$points : 0,
        sx: {
          mr: 0.5,
          height: function height(t) {
            return t.typography.h5.fontSize;
          },
          width: function width(t) {
            return t.typography.h5.fontSize;
          }
        },
        variant: "h5",
        "data-element": "Points",
        "data-component": "QuizWrapper",
        "data-source-file": "index.tsx"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        "data-element": "Typography",
        "data-source-file": "index.tsx",
        children: /*#__PURE__*/_jsx(Translation, {
          "data-element": "Translation",
          "data-source-file": "index.tsx",
          children: function children(t) {
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: ["\xA0", t('for answering correctly')]
            });
          }
        })
      })]
    }), children]
  });
};

export var QuizQuestions = function QuizQuestions(_ref2) {
  var quizQuestions = _ref2.quizQuestions,
      quizForm = _ref2.quizForm,
      responseResults = _ref2.responseResults,
      questionRef = _ref2.questionRef;
  return /*#__PURE__*/_jsx(ContentWrapper, {
    ref: questionRef,
    "data-element": "ContentWrapper",
    "data-component": "QuizQuestions",
    "data-source-file": "index.tsx",
    children: quizQuestions.map(function (quiz) {
      return /*#__PURE__*/_jsx(QuizWrapper, {
        quiz: quiz,
        hasError: !!quizForm.formState.errors[quiz.id],
        children: /*#__PURE__*/_jsx(QuizInput, {
          quiz: quiz,
          quizForm: quizForm,
          responseResults: responseResults
        })
      }, quiz.id);
    })
  });
};